/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { InputLabel, Select, FormControl, IconButton, SelectChangeEvent, MenuItem, Checkbox, ListItemText } from '@mui/material';
import ArgosFlexbox from '../../../../../../../components/Containers/ArgosFlexbox';
import ArgosDialogHeader from '../../../../../../../components/Dialogs/ArgosDialogHeader';
import CloseIcon from '@mui/icons-material/Close';
import { dialogWidth, Header } from '../../Dialogs/constants';
import { StyledArgosDialog } from '../../../../../../../components/Dialogs/ArgosDialog';
import ArgosButton from '../../../../../../../components/Buttons/ArgosButton';
import { useState } from 'react';

interface ChooseDoeParamsWindowProps {
    selectedDOE: string[], // currently selected DOE values to show in graph tooltip
    setSelectedDOE: Function,
    doeNameMap: Map<string, string>,
    isOpen: boolean,
    onClose: () => void
}

const ChooseDoeParamsWindow: React.FC<ChooseDoeParamsWindowProps> = (props) => {
    const [selectedDropdownItems, setSelectedDropdownItems] = useState<any>(props.selectedDOE);
    const handleDropdownChange = (event: SelectChangeEvent<typeof props.selectedDOE>) => {
        const { target: { value }, } = event;
        setSelectedDropdownItems(event.target.value);
    };
    const handleConfirmChanges = () => {
        props.setSelectedDOE(selectedDropdownItems); // Set graph tooltip to show selected DOE values
        props.onClose()
    }

    return (
        <StyledArgosDialog open={props.isOpen} onClose={props.onClose} width={dialogWidth} height={160}>
            <ArgosDialogHeader>
                <ArgosFlexbox style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Header>
                        <div style={{
                            color: 'white',
                            paddingLeft: 5,
                            fontSize: 14
                        }}>
                            Choose DoE Parameters to Display
                        </div>
                    </Header>
                    <IconButton onClick={props.onClose} sx={{ color: 'white', padding: 0, fontSize: 'small' }}>
                        <CloseIcon
                        />
                    </IconButton>
                </ArgosFlexbox>
            </ArgosDialogHeader>
            <ArgosFlexbox vertical style={{ justifyContent: "space-between", height: "100%", padding: 10 }}>
                {/* Dropdown for doeValues */}
                <ArgosFlexbox style={{ display: "flex", justifyContent: "center", alignItems: "center",
                }}>
                    <FormControl fullWidth>
                        <InputLabel id="doe_params">DOE Params</InputLabel>
                        <Select
                            multiple
                            label="DOE Params"
                            labelId='doe_params'
                            type="text"
                            value={selectedDropdownItems}
                            renderValue={(selected) => {
                                return selected.map((item) => props.doeNameMap.get(item)).join(', ')
                            }}
                            fullWidth
                            onChange={handleDropdownChange}
                        >
                            {Array.from(props.doeNameMap.entries()).map(([variable_name, display_name]) => {
                                return (<MenuItem key={variable_name} value={variable_name}
                                    disabled={selectedDropdownItems.length >= 5 && !selectedDropdownItems.includes(variable_name)}>
                                    <Checkbox checked={selectedDropdownItems.includes(variable_name)} />
                                    <ListItemText primary={display_name} />
                                </MenuItem>)
                            })}
                        </Select>
                    </FormControl>
                    <ArgosButton onClick={() => setSelectedDropdownItems([])}>
                        Clear
                    </ArgosButton>
                </ArgosFlexbox>
                <ArgosFlexbox vertical={false} style={{ width: "100%", justifyContent: "space-between"}}>
                    <ArgosButton onClick={() => props.onClose()}>
                        Close
                    </ArgosButton>
                    <ArgosButton onClick={() => handleConfirmChanges()}>
                        Save
                    </ArgosButton>
                </ArgosFlexbox>
            </ArgosFlexbox>
        </StyledArgosDialog>
    );
};

export default ChooseDoeParamsWindow;